import { AfterViewInit, Directive, ElementRef, HostBinding, HostListener, OnInit, ViewContainerRef } from '@angular/core';
import { SidenavContentService } from './sidenav-content.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Directive({
    selector: '[sidenavContentContainer]',
    standalone: true,
})
export class SidenavContentContainerDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}

@Directive({
    selector: `[sidenav-close], sidenav-close, [sidenavClose]`,
    host: { class: 'sidenav-close' },
})
export class SidenavCloseDirective {
    constructor(private _sidenav: SidenavContentService) {
    }

    @HostListener('click', ['$event']) onClick(){
        this._sidenav.close();
    }
}

@Directive({
    selector: '[sidenav-label], sidenav-label, [sidenavLabel]',
    host: { class: 'sidenav-label' },
})
export class SidenavLabelDirective
{
}


@UntilDestroy()
@Directive({
    selector: `[sidenav-content], sidenav-content, [sidenavContent]`,
    host: { class: 'sidenav-content animated fadeIn' },
})
export class SidenavContentDirective implements OnInit {
    @HostBinding('class.with-actions') contentHasActions = false;

    constructor(private _sidenav: SidenavContentService) {
    }

    ngOnInit(): void {
        this._sidenav._actions$.pipe(untilDestroyed(this)).subscribe({
            next: (elementRef) => this.contentHasActions = !!elementRef,
        });
    }
}

@Directive({
    selector: `[sidenav-title], sidenav-title, [sidenavTitle]`,
})
export class SidenavTitleDirective implements AfterViewInit {
    constructor(private _el: ElementRef, private _sidenav: SidenavContentService) {
    }

    ngAfterViewInit(): void {
        this._sidenav._title = this._el;
    }
}

@Directive({
    selector: `[sidenav-actions], sidenav-actions, [sidenavActions]`,
})
export class SidenavActionsDirective implements OnInit {
    constructor(private _el: ElementRef, private _sidenav: SidenavContentService) {
    }

    ngOnInit(): void {
        this._sidenav._actions = this._el;
    }
}
